import { useEffect, useState } from 'react'
import { Divider, Flex, Heading, Stack } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'

import { CustomForm } from 'components/tools/CustomForm/types'
import { DescriptionItem } from 'components/typography'
import CustomFormBuilderDrawer from './components/CustomFormBuilderDrawer'
import { useCustomFormBuilder } from '../../contexts/CustomFormBuilderManagerContext/Provider'

export default function UpdateCustomFormBuilder() {
  const [showUpdateFormButton] = useState(true)

  const { form } = useCustomFormBuilder()

  const formMethods = useForm<CustomForm>({
    defaultValues: {
      score_settings: { classification: { name: '', intervals: [] } },
      name: '',
      has_classification: false,
    },
  })

  useEffect(() => {
    if (form && form.score_settings)
      formMethods.reset({
        ...form,
        score_settings: form.score_settings,
        name: form.score_settings?.classification?.name,
        has_classification: form.has_classification,
      })
  }, [form])

  return (
    <Flex flexDir="column" gap={4}>
      <Heading>Formulário</Heading>

      {showUpdateFormButton && (
        <Stack spacing={4}>
          <DescriptionItem value={formMethods.watch('has_classification') ? 'Sim' : 'Não'} label="Classificação" />

          <CustomFormBuilderDrawer formMethods={formMethods} />
        </Stack>
      )}

      <Divider />
    </Flex>
  )
}
